var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from "react";
import { QuiBadge } from "../QuiBadge/QuiBadge.js";
import { QuiSpinner } from "../QuiSpinner/QuiSpinner.js";
import { QuiIcon } from "../_primitives/QuiIcon/QuiIcon.js";
import classNames from "classnames";
import { components } from "react-select";
import { uniqueId } from "../../utils/index.js";
import { QuiFlexH } from "../_primitives/QuiFlex/QuiFlex.js";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function MultiValue({ data, removeProps, selectProps }) {
    var _a;
    const isBig = selectProps.size === "xl";
    const key = useMemo(() => uniqueId(data), [data]);
    return (React.createElement(QuiBadge, { variant: (_a = selectProps.tagVariant) !== null && _a !== void 0 ? _a : "brand-royal-dark", size: isBig ? "sm" : "xs", key: key },
        data.label,
        React.createElement(QuiIcon, { icon: "x", size: isBig ? "sm" : "xs", onClick: removeProps.onClick, className: classNames("qui-interactive", { "qui-disabled": selectProps.isDisabled }) })));
}
function DropdownIndicator() {
    return React.createElement(QuiIcon, { icon: "chevron-down", className: "qui-interactive" });
}
function ClearIndicator({ clearValue }) {
    return React.createElement(QuiIcon, { icon: "x", onClick: clearValue, className: "qui-interactive" });
}
function LoadingIndicator() {
    return React.createElement(QuiSpinner, { size: "sm" });
}
/** Adds quinine left icon to react-select control */
function Control(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(components.Control, Object.assign({}, props),
        React.createElement(QuiFlexH, { gap: "sm", align: "center", className: "qui-w-100" },
            props.selectProps.iconLeft && React.createElement(QuiIcon, { icon: props.selectProps.iconLeft, className: "qui-color-black-600" }),
            React.createElement(QuiFlexH, { style: { flex: 1 } }, children))));
}
export const ReactSelectCustomComponents = {
    DropdownIndicator,
    ClearIndicator,
    LoadingIndicator,
    MultiValue,
    Control,
};
export const useReactSelectQuinineClassnames = ({ size, invalid, }) => {
    return useMemo(() => ({
        control: ({ isDisabled }) => classNames(`qui-select qui-select--${size !== null && size !== void 0 ? size : "md"}`, {
            "qui-invalid": invalid,
            "qui-disabled": isDisabled,
        }),
        container: () => "qui-select-container",
        input: () => `qui-select__input`,
        menu: () => "qui-select__menu",
        menuList: () => "qui-select__menu-items",
        noOptionsMessage: () => "qui-select__no-items",
        option: ({ isSelected, isFocused }) => classNames("qui-select__menu-item", {
            "qui-select__menu-item--selected": isSelected,
            "qui-select__menu-item--focus": isFocused,
        }),
        indicatorsContainer: () => "qui-select__indicator-container",
        valueContainer: () => "qui-select__value-container",
        placeholder: () => "qui-text-muted",
    }), [invalid, size]);
};
